@if (!loading) {
  <div class="routed-component-layout">
    <div class="routed-component-body">
      <div class="routed-component-title-block">
        <h2>{{ 'REGISTRATION.DIRECT_THANK_YOU.TITLE' | translate }}</h2>
        <div class="image emailimage"></div>
      </div>
      @if (companyName) {
        <p>{{ 'REGISTRATION.DIRECT_THANK_YOU.LINE_1' | translate : { companyName: companyName } }}</p>
      }
      @if (email) {
        <p>{{ 'REGISTRATION.DIRECT_THANK_YOU.LINE_2' | translate : { email: email } }}</p>
      }

      <p>{{ 'REGISTRATION.DIRECT_THANK_YOU.LINE_3' | translate }}</p>
      <p>{{ 'REGISTRATION.DIRECT_THANK_YOU.LINE_4' | translate }}</p>
    
       <div class="navigation-controls-layout">
          <div class="idv-cta-section">
            <button class="primary centered" (click)="onClickCTA()">{{ 'REGISTRATION.DIRECT_THANK_YOU.BUTTON' | translate }}</button>
          </div>
        </div>
    </div>
  </div>
}
